<div box>
  <div title><div logo class="mb-10"></div></div>
  <form nz-form [formGroup]="form" (ngSubmit)="login()">
    <nz-alert *ngIf="ipBlockedError"
              nzType="error"
              nzShowIcon
              nzMessage="Access Restricted"
              [nzDescription]="ipBlockedError"
              class="mb-4 text-left">
    </nz-alert>
    
    <!-- Step 1: Initial Login (Email + Password) -->
    <ng-container *ngIf="currentStep !== 'organization'">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="getErrorMessage(form.controls['email'])">
          <nz-input-group nzPrefixIcon="user" nzSize="large">
            <input type="text" nz-input formControlName="email" placeholder="Email"/>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="getErrorMessage(form.controls['password'])">
          <nz-input-group nzPrefixIcon="lock" nzSize="large">
            <input type="password" nz-input formControlName="password" placeholder="Password"/>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      
      <button nzSize="large"
              nzType="primary"
              nz-button
              nzBlock
              [nzLoading]="isLoading">
        Log in
      </button>

      <ng-container *ngIf="isSaas">
        <nz-divider nzText="OR"></nz-divider>
        <div>
          <button
            (click)="doGoogleLogin()"
            nzSize="large"
            nzType="default"
            nz-button
            nzBlock
            type="button"
            [nzLoading]="isGoogleLoading"
          >
            <i nz-icon nzType="google"></i>
            Sign In with Google
          </button>
        </div>
      </ng-container>

      <div class="text-center pt-4">
        <a [routerLink]="['/', 'forget-password']">Forgot password</a>
        <a *ngIf="isSaas" class="ml-8" [routerLink]="['/', 'register', 'user']">Register Now</a>
      </div>
    </ng-container>

    <!-- Step 2: Multi-Tenant Organization Selector -->
    <ng-container *ngIf="currentStep === 'organization'">
      <div class="email-display-card mb-6">
        <div class="flex justify-between items-center">
          <span class="user-email-text">
            <i nz-icon nzType="user" class="mr-2"></i>{{ form.controls['email'].value }}
          </span>
          <a (click)="goBack()" class="change-email-btn">
            Change
          </a>
        </div>
      </div>

      <nz-form-item class="mb-6 tenant-selector-item">
        <div class="selector-label mb-2">Select Organization</div>
        <nz-form-control>
          <nz-select [(ngModel)]="selectedTenantId" 
                     [ngModelOptions]="{standalone: true}" 
                     nzShowSearch 
                     nzPlaceHolder="Select Organization" 
                     nzSize="large" 
                     class="w-full">
            <nz-option *ngFor="let t of availableTenants" 
                       [nzValue]="t.tenantId" 
                       [nzLabel]="t.companyName || t.tenantId">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <button nzSize="large"
              nzType="primary"
              nz-button
              nzBlock
              type="button"
              (click)="selectOrganizationAndLogin()"
              [nzLoading]="isLoading">
        Access Organization
      </button>
    </ng-container>

  </form>
</div>
